import { h6Styles } from 'components/reusable-css';
import styled from 'styled-components';
import { variables } from 'variables';

export const PassSC = styled.div`
  background: ${(props) => props.theme.pageBackgroundColor};
  width: 100%;
  padding: ${variables.pageContentPadding}px;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const ChangePasswords = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const FormDiv = styled.div`
  padding-bottom: 2.4em;
`;

export const Label = styled.h6`
  padding-top: 2.8rem;
  font-weight: bold;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  @media only screen and (max-width: 899px) {
    padding-top: 2rem;
  }
`;

export const LabelDescription = styled.h6`
  padding-top: 2.8rem;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  @media only screen and (max-width: 899px) {
    padding-top: 0;
  }
`;
